import { formatDate } from '@luxuryescapes/lib-refunds'
import { Refundable } from 'components/Common/CancellationPolicies/utils/getCancellationPolicyStatus'

export interface PropertyRateCancellationDisplayText {
  primary: string
  secondary?: string
  highlightPrimary: boolean
}

export function getPropertyRateCancellationDisplayText(
  rate: App.PropertyRate,
  timezone: string,
): PropertyRateCancellationDisplayText {
  const { headlineCancellationPolicyType, headlineCancellationPolicyStart } = rate

  if (headlineCancellationPolicyType === 'nonRefundable') {
    return {
      primary: Refundable.Non,
      highlightPrimary: false,
    }
  }

  const refundText = headlineCancellationPolicyType === 'fullyRefundable'
    ? Refundable.Fully
    : Refundable.Partial

  if (headlineCancellationPolicyStart) {
    const formattedDate = formatDate.formattedShortDateByTimezone(
      headlineCancellationPolicyStart,
      timezone,
    )

    return {
      primary: refundText,
      secondary: `until ${formattedDate}`,
      highlightPrimary: true,
    }
  }

  return {
    primary: refundText,
    highlightPrimary: true,
  }
}
